"use client";
// React
import React, { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { ChevronDown, User2 } from "lucide-react";

// Components
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

// Stores
import { useUserStore } from "@/_stores/use-user-store";
import { useWalletStore } from "@/_stores/use-wallet-store";

const UserProfile = () => {
  const { user, role, loading, loadUser, signOut } = useUserStore();
  const { balance, loadingBalance, fetchBalance } = useWalletStore();
  const router = useRouter();
  const pathname = usePathname();
  useEffect(() => {
    loadUser();
    fetchBalance();
  }, [loadUser, fetchBalance]);

  const handleSignOut = async () => {
    await signOut();
    router.refresh();
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="cursor-pointer">
        <div className="flex gap-1 items-center">
          <User2 className="mt-1 text-sm" />
          <span className="max-lg:hidden lg:block mt-1 text-sm font-semibold">
            {user?.email}
          </span>
          <ChevronDown className="mt-1 text-sm" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          <span className="block text-sm">{user?.email ?? ""}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-gray-300" />
        {role === "admin" && (
          <DropdownMenuItem onClick={() => router.push("/admin")}>
            <span>Admin</span>
          </DropdownMenuItem>
        )}
        {(pathname === "/" ||
          pathname.startsWith("/customer") ||
          pathname.startsWith("/admin")) && (
            <DropdownMenuItem
            onClick={() => {
              const pathParts = pathname.split("/");
              if (pathParts.includes("admin") && pathParts.includes("user")) {
                const userId = pathParts[pathParts.indexOf("user") + 1]; // Extract user_id from URL
                router.push(`/bots?user_id=${userId}`);
              } else {
                router.push("/bots");
              }
            }}
          >
            <span>My Bots</span>
          </DropdownMenuItem>
          
        )}

        <DropdownMenuItem onClick={() => router.push("/wallet")}>
          <div className="flex justify-between items-center w-full">
            <span>Wallet</span>
            <span className="font-semibold">{balance}</span>
          </div>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleSignOut}>
          <span>Sign out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserProfile;
